/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Assistant_Prompt_Q3_C2Inputs */



/**
* | output |
* | --- |
* | "Thorough, with the reasoning" |
*
* @param {Uno_Field_Assistant_Prompt_Q3_C2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_assistant_prompt_q3_c2 = /** @type {((inputs?: Uno_Field_Assistant_Prompt_Q3_C2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Assistant_Prompt_Q3_C2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausführlich, mit Begründung")
	return /** @type {LocalizedString} */ ("Thorough, with the reasoning")
});